import React from 'react'

const LoopComponent = () => {
  return (
    <div>
        <img src="/assets/images/parentdash/independence.gif" alt="loop" style={{width:'100%'}} />
    </div>
  )
}

export default LoopComponent